import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

// Switched from 'fa' (Solid) to 'fi' (Feather Outlined) for the minimalist look
import { 
  FiHome, 
  FiShoppingCart, 
  FiTrendingUp, 
  FiBox, 
  FiDatabase, 
  FiUsers, 
  FiPlusSquare,
  FiBarChart2,
  FiFileText,
  FiBriefcase,
  FiActivity,
  FiSend,
  FiBell,
  FiSettings,
  FiCalendar,
  FiHelpCircle,
  FiPower,
  FiChevronLeft,
  FiChevronRight
} from "react-icons/fi";

import "../styles/Sidebar.css";

function Sidebar() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (isCollapsed) {
      document.body.classList.add("sidebar-is-collapsed");
    } else {
      document.body.classList.remove("sidebar-is-collapsed");
    }
    return () => document.body.classList.remove("sidebar-is-collapsed");
  }, [isCollapsed]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.reload();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className={`sidebar-container ${isCollapsed ? "collapsed" : "expanded"}`}>
      <div className="sidebar">
        
        {/* Header Area */}
        <div className="sidebar-header">
          <div className="brand-section">
            <div className="logo-icon">
              <div className="bar short"></div>
              <div className="bar tall"></div>
              <div className="bar medium"></div>
            </div>
            {!isCollapsed && <span className="brand-text">MyOwnBill</span>}
          </div>

          {!isCollapsed && (
            <div 
              className="header-toggle" 
              onClick={() => setIsCollapsed(true)}
              title="Collapse Sidebar"
            >
              <FiChevronLeft size={20} />
            </div>
          )}
        </div>

        {isCollapsed && (
          <div className="collapsed-toggle" onClick={() => setIsCollapsed(false)} title="Expand Sidebar">
            <FiChevronRight size={20} />
          </div>
        )}

        {/* Scrollable Main Navigation */}
        <div className="sidebar-menu">
          <NavLink to="/" end className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiHome /> {!isCollapsed && <span>Dashboard</span>}
          </NavLink>

          <NavLink to="/billing" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiShoppingCart /> {!isCollapsed && <span>Billing (POS)</span>}
          </NavLink>

          <NavLink to="/sales" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiTrendingUp /> {!isCollapsed && <span>Sales</span>}
          </NavLink>

          <NavLink to="/products" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiBox /> {!isCollapsed && <span>Products</span>}
          </NavLink>

          <NavLink to="/inventory" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiDatabase /> {!isCollapsed && <span>Inventory</span>}
          </NavLink>

          <NavLink to="/customers" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiUsers /> {!isCollapsed && <span>Customers</span>}
          </NavLink>

          <NavLink to="/suppliers" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiUsers /> {!isCollapsed && <span>Suppliers</span>}
          </NavLink>

          <NavLink to="/purchases" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiShoppingCart /> {!isCollapsed && <span>Purchases</span>}
          </NavLink>

          <NavLink to="/expenses" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiPlusSquare /> {!isCollapsed && <span>Expenses</span>}
          </NavLink>

          <NavLink to="/reports" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiBarChart2 /> {!isCollapsed && <span>Reports</span>}
          </NavLink>

          <NavLink to="/gst-tax" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiFileText /> {!isCollapsed && <span>GST & Tax</span>}
          </NavLink>

          <NavLink to="/accounts" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiBriefcase /> {!isCollapsed && <span>Accounts</span>}
          </NavLink>

          <NavLink to="/employees" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiUsers /> {!isCollapsed && <span>Employees</span>}
          </NavLink>

          <NavLink to="/analytics" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiActivity /> {!isCollapsed && <span>Analytics</span>}
          </NavLink>

          {/* Missing items added back here */}
          <NavLink to="/marketing" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiSend /> {!isCollapsed && <span>Marketing</span>}
          </NavLink>

          <NavLink to="/notifications" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiBell /> 
            {!isCollapsed && <span>Notifications</span>}
            {!isCollapsed && <span className="notification-badge">8</span>}
          </NavLink>
        </div>

        {/* Pinned Bottom Navigation */}
        <div className="sidebar-bottom">
          <NavLink to="/settings" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiSettings /> {!isCollapsed && <span>Settings</span>}
          </NavLink>

          <NavLink to="/subscription" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiCalendar /> {!isCollapsed && <span>Subscription</span>}
          </NavLink>

          <NavLink to="/support" className={({ isActive }) => isActive ? "sidebar-link active-menu" : "sidebar-link"}>
            <FiHelpCircle /> {!isCollapsed && <span>Help & Support</span>}
          </NavLink>
          
          <div className="sidebar-link logout-btn" onClick={handleLogout}>
            <FiPower size={18} /> {!isCollapsed && <span>Logout</span>}
          </div>
        </div>

      </div>
    </div>
  );
}

export default Sidebar;